<template>
  <div class="excellent-capabilities-deployment-manual">
    <action-bar>
      <div class="fill"></div>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>
    <common-bg-plate>
      <div class="deployment-manual-content">
        <div class="deployment-manual-title">{{ title }}</div>
        <div class="deployment-manual-details">
          <detail-section
            v-for="(item, index) in instructionsItem"
            :key="index"
            class="deployment-manual-detail"
            :title="item.title"
            :show-border="true"
          >
            <div v-for="(itemsub, indexsub) in item.step" :key="indexsub" class="deployment-manual-step">
              <p class="deployment-manual-step-name">{{ itemsub.title }}</p>
              <p class="deployment-manual-step-content">{{ itemsub.text }}</p>
            </div>
          </detail-section>
        </div>
      </div>
    </common-bg-plate>
  </div>
</template>

<script>
export default {
  name: 'DeploymentManual',

  data() {
    return {
      btnList: [
        {
          btnContent: '下载部署文档',
          click: () => {
            return this.downLoadFile()
          },
          icon: 'icon-download'
        }
      ],
      title: '目前三种算法服务仅支持linux内核服务器部署',
      instructionsItem: [
        {
          title: '一键启动所有服务：',
          step: [
            {
              title: '第一步：',
              text: '将压缩包拷贝到服务器上，解压缩'
            },
            {
              title: '第二步：',
              text:
                '进入到解压后的根目录，在命令行输入：chmod +x start.sh./start.sh  如果提示 "all servers are startting, pls check log..." 表示启动成功'
            }
          ]
        },

        {
          title: '一键关闭所有服务：',
          step: [
            {
              title: '第一步：',
              text:
                '进入到解压后的根目录，在命令行输入：chmod +x stop.sh./stop.sh  如果提示 "all servers are stopped" 表示关闭成功'
            }
          ]
        },

        {
          title: '如果想单独启动或者停止服务',
          step: [
            {
              title: '第一步:',
              text: '在根目录 cd ... 进入对应服务的文件夹'
            },
            {
              title: '第二步：',
              text: 'chmod +x start.sh 或者 chmod +x stop.sh 分别对应启动和停止'
            },
            {
              title: '第三步：',
              text: './start.sh 或者 ./stop.sh 分别对应启动和停止'
            }
          ]
        },

        {
          title: '如果想要修改服务端口',
          step: [
            {
              title: '第一步:',
              text: '按上述步骤操作停止相应的服务'
            },
            {
              title: '第二步：',
              text: 'cd ... 进入该服务的 config_yaml 文件夹 然后命令行输入 vim config.yaml'
            },
            {
              title: '第三步：',
              text:
                '在 port 后修改端口号 然后输入 esc 再输入 :wq 保存退出 重新启动服务即可修改端口后记得在cbaas前端页面上修改部署配置'
            }
          ]
        }
      ]
    }
  },
  methods: {
    downLoadFile() {
      const content =
        '目前三种算法服务仅支持linux内核服务器部署\n' +
        '一键启动所有服务：\n' +
        '第一步：\n' +
        '将压缩包拷贝到服务器上，解压缩\n' +
        '第二步：\n' +
        '进入到解压后的根目录，在命令行输入：chmod + x start.sh./ start.sh 如果提示 all servers are startting, pls check log... 表示启动成功\n' +
        '一键关闭所有服务：\n' +
        '第一步：\n' +
        '进入到解压后的根目录，在命令行输入：chmod + x stop.sh./ stop.sh 如果提示 all servers are stopped 表示关闭成功\n' +
        '如果想单独启动或者停止服务\n' +
        '第一步:\n' +
        '在根目录 cd ...进入对应服务的文件夹\n' +
        '第二步：\n' +
        'chmod + x start.sh 或者 chmod + x stop.sh 分别对应启动和停止\n' +
        '第三步：\n' +
        './start.sh 或者 ./stop.sh 分别对应启动和停止\n' +
        '如果想要修改服务端口\n' +
        '第一步:\n' +
        '按上述步骤操作停止相应的服务\n' +
        '第二步：\n' +
        'cd ... 进入该服务的 config_yaml 文件夹 然后命令行输入 vim config.yaml\n' +
        '第三步：\n' +
        '在 port 后修改端口号 然后输入 esc 再输入:wq 保存退出 重新启动服务即可修改端口后记得在cbaas前端页面上修改部署配置\n'

      const name = 'deployment-instructions.txt'
      this.$utils.createFileAndDownload(name, content)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.excellent-capabilities-deployment-manual {
  @include adaptation(
    (
      --excellent-capabilities-deployment-manual-title-padding: 16px,
      --excellent-capabilities-deployment-manual-title-font-size: 18px,
      --excellent-capabilities-deployment-manual-step-padding: 0 16px,
      --excellent-capabilities-deployment-manual-step-name-font-size: 16px,
      --excellent-capabilities-deployment-manual-step-content-padding: 4px 16px
    )
  );
  color: var(--base-color-text-primary);

  .deployment-manual-title {
    padding: var(--excellent-capabilities-deployment-manual-title-padding);
    font-size: var(--excellent-capabilities-deployment-manual-title-font-size);
    font-weight: 700;
  }

  .deployment-manual-step {
    padding: var(--excellent-capabilities-deployment-manual-step-padding);
    .deployment-manual-step-name {
      font-size: var(--excellent-capabilities-deployment-manual-step-name-font-size);
      font-weight: 500;
    }

    .deployment-manual-step-content {
      padding: var(--excellent-capabilities-deployment-manual-step-content-padding);
    }
  }
}
</style>
